import { forwardRef } from "react";

import { Divider, DividerProps, useTheme } from "@mui/material";

import { InvalidThemeErrorMessage } from "../InvalidThemeErrorMessage";

import { mergeSx } from "@/common/helpers/mergeSx";

export interface FormDividerProps extends Omit<DividerProps, "variant"> {
  variant?: "solid" | "dashed";
}

export const FormDivider = forwardRef<HTMLHRElement, FormDividerProps>(({ sx, variant = "solid", ...rest }, ref) => {
  const theme = useTheme();

  if (!theme.palette.formsComponents?.divider) {
    return <InvalidThemeErrorMessage />;
  }

  return (
    <Divider
      {...rest}
      ref={ref}
      sx={mergeSx(
        {
          borderColor: theme.palette.formsComponents.divider.borderColor,
          borderStyle: variant === "dashed" ? "dashed" : "solid",
        },
        sx
      )}
    />
  );
});

FormDivider.displayName = "FormDivider";
